import { Layout, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './../styles/contactPage.css';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { buildCanonicalUrl, buildOgImageUrl } from '../utils/seo';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const ContactPage = () => {
  const { t } = useTranslation();
  const canonicalUrl = buildCanonicalUrl('/contact');
  const contactJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    url: canonicalUrl,
    mainEntity: {
      '@type': 'Organization',
      name: 'AIlicorn',
      url: buildCanonicalUrl('/'),
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        email: 'service@ailicorn.com',
        availableLanguage: ['en', 'zh-TW'],
      },
    },
  };

  return (
    <Layout className="contact-page-layout">
      <SEO
        title={t('seo.contact.title')}
        description={t('seo.contact.description')}
        keywords={t('seo.contact.keywords')}
        ogImage={buildOgImageUrl('/logo.png')}
        ogUrl={canonicalUrl}
        canonical={canonicalUrl}
        jsonLd={contactJsonLd}
      />
      <Content className="contact-page">
        <div className="section-container">
          <div className="section-header">
            <MailOutlined className="section-icon" />
            <Title level={2}>{t('contact.title')}</Title>
            <Paragraph className="section-subtitle">
              {t('contact.subtitle')}
            </Paragraph>
          </div>
          
          <div className="form-container">
            <iframe
              src="https://forms.gle/vpnvva5yeKvkJf7L7"
              width="100%"
              height="1200px"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
              title="Contact Form"
            >{t('contact.loading')}</iframe>
          </div>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default ContactPage;
